import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';

Swiper.use([Autoplay, EffectFade]);

class HeroPremium {
    constructor(el) {
        if (!this.set(el)) return;

        if (
            document.readyState === 'complete' ||
            (document.readyState !== 'loading' &&
                !document.documentElement.doScroll)
        ) {
            this.init();
        } else {
            document.addEventListener('DOMContentLoaded', this.init.bind(this));
        }
    }

    set(el) {
        if (!el) return true;

        this.root = el;
        this.bgSliderEl = this.root.querySelector('[data-hero-premium-swiper]');

        this.bgSwiper = null;

        return true;
    }

    init() {
        this.setBgSwiper();
    }

    setBgSwiper() {
        if (!this.bgSliderEl) return;

        this.bgSwiper = new Swiper(this.bgSliderEl, {
            slidesPerView: 'auto',
            modules: [Autoplay],
            effect: 'fade',
            speed: 1000,
            autoplay: {
                delay: 4000,
                disableOnInteraction: true,
            },
        });
    }
}

const initHero = () => {
    const sections = document.querySelectorAll('[data-hero-premium]');
    if (sections) sections.forEach(item => new HeroPremium(item));
};

initHero();